import { ModalBackground, ModalContent, ModalFooter, ModalLayout, ModalTitle } from './ModalForms';
import styled from 'styled-components';
import BasicButton from 'components/Buttons/BasicButton';
import { CloseButtonWrapper } from 'styles/Modal/modalStyle';
import Noti_Warning from 'assets/Icons/ToastIcons/Noti_Warning';
import CloseDialogue from 'assets/Icons/DeleteIcon/CloseDialogue';
import { IModalProps } from 'models/Common/modalTypes';

const BasicConfirmModal = ({ cancelButton, confirmButton, title, content, firstButton, secondButton, infoContent }: IModalProps) => {
    return (
        <ModalBackground>
            <ModalLayout $width={'520px'}>
                <ModalTitleAndContentContainer>
                    <TitleAndIconWrapper>
                        <Noti_Warning />
                        <ModalTitle>{title}</ModalTitle>
                    </TitleAndIconWrapper>
                    <ModalContent>{content}</ModalContent>
                    {infoContent && infoContent}
                </ModalTitleAndContentContainer>
                <ModalFooter>
                    <BasicButton $width='160px' $height='48px' onClick={cancelButton} $type={'anotherFill'}>
                        {firstButton}
                    </BasicButton>
                    <BasicButton $width='160px' $height='48px' onClick={confirmButton} $type={'fill'}>
                        {secondButton}
                    </BasicButton>
                </ModalFooter>
                <CloseButtonWrapper onClick={cancelButton}>
                    <CloseDialogue />
                </CloseButtonWrapper>
            </ModalLayout>
        </ModalBackground>
    );
};

export default BasicConfirmModal;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
`;

const TitleAndIconWrapper = styled.div`
    display: flex;
    gap: 8px;
`;
